import Card from 'react-bootstrap/Card'
import React, { useRef } from 'react'

import { Field } from 'formik'
import { Col, Row } from 'react-bootstrap'

import { InputDateComponent, InputTextComponent } from 'recupero-comunes'

import NumberFormat from 'react-number-format'
import Select from '../../../utils/select'

const FormCivilLiability = ({
  data,
  values,
  setFieldValue,
  errors,
  form,
  gestionCase
}) => {
  const mPago = useRef(null)
  const mProvision = useRef(null)
  const mIndeniza = useRef(null)
  const mCOB = useRef(null)
  const mSituacion = useRef(null)

  return (
    <Card.Body>
      <Card.Header
        className=' border border-2'
        style={{backgroundColor: '#4F517A', color: 'white'}}
      >
        {form['antecliquidadef-title-seccion']}
      </Card.Header>

      {/* -------------------- primera seccion--- */}
      {/*<Row className='mt-4'>
        <Col md='2'>
          <dt className='text-sm font-medium text-gray-500'>
            {form['antecliquidadef-lbl-liquidadorrc']}
          </dt>
          <dd className='mt-1 text-sm text-gray-900 '>
            {gestionCase?.Liquidador}
          </dd>
        </Col>
        <Col md='2'>
          <dt className='text-sm font-medium text-gray-500'>
            {form['antecliquidadef-cmb-analistarc']}
          </dt>
          <dd className='mt-1 text-sm text-gray-900 '>
            {gestionCase?.AnalistaSiniestro}
          </dd>
        </Col>
      </Row>*/}

      {/* -------------------- Monto Pago--- */}
      <Row className='mt-2'>
        <Col md='2'>
          {data?.cbCoin?.length > 0 ? (
            <Select
              ref={mPago}
              name='mdaPago'
              label={form['antecliquidapp-cmb-mdapago']}
              defaultInputValue={
                data.cbCoin.find(
                  (item) => item.id === data?.liquidation?.codMonedaPago
                )?.nombre
              }
              labelKey='nombre'
              options={data.cbCoin ? data.cbCoin : []}
            />
          ) : null}
        </Col>
        <Col md='2' style={{fontWeight: 'bold', fontSize: '14px'}}>
          {form['antecliquidapp-input-mtopago']}
          <NumberFormat 
            className='form-control mt-2'
            name='mtoPago'
            value={values.mtoPago}
            thousandSeparator='.'
            decimalScale={2}
            decimalSeparator={values.mdaPago === 30001 ? null : ','}
            onValueChange={(e) => {
              setFieldValue('mtoPago', e.floatValue, true)
            }}
          />
          {errors?.mtoPago ? (
            <div className='text-danger'>{errors?.mtoPago}</div>
          ) : null}
        </Col>
        <Col md='3' style={{fontWeight: 'bold', fontSize: '14px'}}>
          <InputDateComponent
            name='fechaPago'
            label={form['antecliquidapt-input-fechapago']}
          />
        </Col>

        <Col md='3'>
          {data?.cbPaymentSituaction?.length > 0 ? (
            <Select
              ref={mSituacion}
              name='situacionPago'
              label={form['antecliquidapp-cmb-sitpago']}
              defaultInputValue={
                data.cbPaymentSituaction.find(
                  (item) => item.id === data?.liquidation?.codSituacionPago
                )?.nombre
              }
              labelKey='nombre'
              options={data.cbPaymentSituaction ? data.cbPaymentSituaction : []}
            />
          ) : null}
        </Col>
      </Row>
      <Row className='mt-2'>
        {/* -------------------- Monto Indenizacion--- */}
        <Col md='2'>
          {data?.cbCoin?.length > 0 ? (
            <Select
              ref={mIndeniza}
              name='mdaIndemniza'
              label={form['antecliquidapt-cmb-mdaindemniza']}
              defaultInputValue={
                data.cbCoin.find(
                  (item) => item.id === data?.liquidation?.codMonedaIndeminza
                )?.nombre
              }
              labelKey='nombre'
              options={data.cbCoin ? data.cbCoin : []}
            />
          ) : null}
        </Col>
        <Col md='2' style={{fontWeight: 'bold', fontSize: '14px'}}>
          {form['antecliquidapt-input-mtoindemniza']}
          <NumberFormat
            className='form-control mt-2'
            name='mtoIndemnizacion'
            value={values.mtoIndemnizacion}
            thousandSeparator='.'
            decimalScale={2}
            decimalSeparator={values.mdaIndemniza === 30001 ? null : ','}
            onValueChange={(e) => {
              setFieldValue('mtoIndemnizacion', e.floatValue, true)
            }}
          />
          {errors?.mtoIndemnizacion ? (
            <div className='text-danger'>{errors?.mtoIndemnizacion}</div>
          ) : null}
        </Col>

        <Col md='3'>
          <Row className='mt-3'>
            <Col md='1'>
              <Field
                className=' mt-4 '
                type='checkbox'
                style={{
                  width: '25px',
                  height: '25px'
                }}
                name='indInformeLiquida'
              />
            </Col>
            <Col
              className='mt-4'
              style={{
                marginLeft: '8px'
              }}
              md='10'
            >
              {form['antecliquidadef-chk-liqasegurado-infliquida']}
            </Col>
          </Row>
        </Col>

        <Col md='3' style={{fontWeight: 'bold', fontSize: '14px'}}>
          <InputDateComponent
            name='fechaInforme'
            label={form['antecliquidadef-input-fechainforme']}
          />
        </Col>
      </Row>

      {/* -------------------- Monto Provisión--- */}
      <Row className='mt-2'>
        <Col md='2'>
          {data?.cbCoin?.length > 0 ? (
            <Select
              ref={mProvision}
              name='mdaProvision'
              label={form['antecliquidapt-cmb-mdaprovision']}
              defaultInputValue={
                data.cbCoin.find(
                  (item) => item.id === data?.liquidation?.codMonedaProvision
                )?.nombre
              }
              labelKey='nombre'
              options={data.cbCoin ? data.cbCoin : []}
            />
          ) : null}
        </Col>
        <Col md='2' style={{fontWeight: 'bold', fontSize: '14px'}}>
          {form['antecliquidapt-input-mtoprovision']}
          <NumberFormat
            className='form-control mt-2'
            name='mtoProvision'
            thousandSeparator='.'
            decimalScale={2}
            value={values.mtoProvision}
            decimalSeparator={values.mdaProvision === 30001 ? null : ','}
            onValueChange={(e) => {
              setFieldValue('mtoProvision', e.floatValue, true)
            }}
          />
          {errors?.mtoProvision ? (
            <div className='text-danger'>{errors?.mtoProvision}</div>
          ) : null}
        </Col>
      </Row>
      {/* -------------------- Monto PolizaR Cexceso--- */}
      <Row className='mt-3'>
        <Col md='2' style={{fontWeight: 'bold', fontSize: '14px'}}>
          <InputTextComponent
            name='polizaRCexceso'
            type='text'
            label={form['antecliquidadef-input-polrcexceso']}
          />
        </Col>
        <Col md='2' style={{fontWeight: 'bold', fontSize: '14px'}}>
          <InputTextComponent
            name='siniestroRCexceso'
            type='text'
            label={form['antecliquidadef-input-sinircexceso']}
          />
        </Col>
        <Col md='3' style={{fontWeight: 'bold', fontSize: '14px'}} >
          <InputDateComponent
            name='fechaSiniestro'
            label={form['antecliquidadef-input-fechasiniestrorc']}
          />
        </Col>
        <Col md='3'>
          {data?.cbCoin?.length > 0 ? (
            <Select
              ref={mCOB}
              name='mdaCobertura'
              label={form['antecliquidadef-input-mdacobrc']}
              defaultInputValue={
                data.cbCoin.find(
                  (item) =>
                    item.id === data?.liquidation?.datosRcExceso?.mdaCobertura
                )?.nombre
              }
              labelKey='nombre'
              options={data.cbCoin ? data.cbCoin : []}
            />
          ) : null}
        </Col>
        <Col md='2' style={{fontWeight: 'bold', fontSize: '14px'}}> 
          {form['antecliquidadef-input-mtocobrc']}
          <NumberFormat
            className='form-control mt-2'
            name='mtoCobertura'
            thousandSeparator='.'
            decimalScale={2}
            value={values.mtoCobertura}
            decimalSeparator={values.mdaCobertura === 30001 ? null : ','}
            onValueChange={(e) => {
              setFieldValue('mtoCobertura', e.floatValue, true)
            }}
          />
          {errors?.mtoCobertura ? (
            <div className='text-danger'>{errors?.mtoCobertura}</div>
          ) : null}
        </Col>
      </Row>
      {/* -------------------- ultima seccion--- */}
      {/*<Card.Header
        className='mt-2 border border-2'
        style={{ background: 'gray', color: 'white' }}
      >
        {form['antecliquidadef-title-liqasegurado']}
      </Card.Header>
      <Row className='mt-2'>
        <Col md='2'>
          <dt className='text-sm font-medium text-gray-500'>
            {form['antecliquidapt-cmb-mdapago']}
          </dt>
          <dd className='mt-1 text-sm text-gray-900 '>
            {data.cbCoin.length > 0
              ? data.cbCoin.find(
                  (item) =>
                    item.id ===
                    data?.liquidation?.liquidacionAsegurado?.codMonedaPago
                )?.nombre
              : data?.liquidation?.liquidacionAsegurado?.codMonedaPago}
          </dd>
        </Col>
        <Col md='2'>
          <dt className='text-sm font-medium text-gray-500'>
            {form['antecliquidapt-input-mtopago']}
          </dt>
          <dd className='mt-1 text-sm text-gray-900 '>
            {data?.liquidation?.liquidacionAsegurado?.mtoPago}
          </dd>
        </Col>
        <Col md='2'>
          <dt className='text-sm font-medium text-gray-500'>
            {form['antecliquidapp-input-fecultpago']}
          </dt>
          <dd className='mt-1 text-sm text-gray-900 '>
            {data?.liquidation?.liquidacionAsegurado?.fechaUltimoPagoFormat}
          </dd>
        </Col>
        <Col md='2'>
          <dt className='text-sm font-medium text-gray-500'>
            {form['antecliquidapp-input-fechainforme']}
          </dt>
          <dd className='mt-1 text-sm text-gray-900 '>
            {data?.liquidation?.liquidacionAsegurado?.fechaInformeFormat}
          </dd>
        </Col>
        </Row>*/}
    </Card.Body>
  )
}

export default FormCivilLiability
